import type ImageType from "@travily/types/shared/Image";
import { Avatar, type AvatarColor, type AvatarShape, type AvatarSize } from "@ui/components/Avatar";
import type { ReactNode } from "react";

interface PersonAvatarPerson {
  avatar?: ImageType | null;
  initial?: string | null;
}

export interface PersonAvatarProps {
  children?: ReactNode;
  className?: string;
  color?: AvatarColor;
  person: PersonAvatarPerson;
  shape?: AvatarShape;
  size?: AvatarSize;
}

export function PersonAvatar({ children, className, color = "red", person, shape, size }: PersonAvatarProps) {
  return (
    <Avatar.Root
      className={className}
      color={color}
      image={person.avatar}
      initial={person.initial}
      shape={shape}
      size={size}
    >
      {children}
    </Avatar.Root>
  );
}
